import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Mixin from '@/helpers/mixin'
import VueRouter from 'vue-router'
import router from './router'
import './custom.css'


Vue.mixin(Mixin)
Vue.use(VueRouter)
Vue.use(BootstrapVue)

Vue.config.productionTip = false

import moment from 'moment'

Vue.filter('formatDateTime', function(value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY hh:mm:ss A')
    }
});

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
    }
});

Vue.filter('previousDate', function(value) {
    if (value) {
        return moment(String(value)).subtract(1, 'days').format('MM/DD/YYYY')
    }
});

Vue.filter('nextDate', function(value) {
    if (value) {
        return moment(String(value)).add(1, 'days').format('MM/DD/YYYY')
    }
});

new Vue({
  render: h => h(App),
    router
}).$mount('#app')
